import React from "react";
import SearchSelect from "./Select";
class SelectComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        label: this.props.value?.toString() || null,
        value: this.props.value,
      },
      inputValue: this.props.value ?? "",
      hasError: false,
    };
    this.cancelRequest = null;
  }

  handleChange = (value) => {
    this.setState({ value }, this.updateParent);
    if (value) {
      this.props.api.suppressTab = false;
    }
  };

  updateParent() {
    if (this.props.onChange) {
      this.props.onChange(this.state.value);
    }
  }

  onInputChange = (inputValue) => {
    this.setState({
      inputValue,
    });
    if (!inputValue) {
      this.props.api.suppressTab = false;
    }
  };

  getOptions = (options, hasError = false) => {
    const isLoading = !options.length;
    this.props.api.suppressTab = isLoading;
    if (hasError) {
      this.setState({
        hasError,
      });
      return;
    }
    if (!this.props.value) {
      this.handleChange(options[0]);
    }
  };

  initializeCancelToken = (c) => {
    this.cancelRequest = c;
  };

  fetchOptions = (inputValue) => {
    this.setState({
      hasError: false,
    });
    this.cancelRequest?.("Request canceled"); // Cancel ongoing request if any
    const { api, suppressTabOnLoading, fetchData, terminalCode } =
      this.props;
    const { getOptions, initializeCancelToken } = this;
    api.suppressTab = inputValue || suppressTabOnLoading(api);
    return fetchData?.({
      inputValue,
      getOptions,
      initializeCancelToken,
      terminalCode
    });
  };

  handleKeyDown = (event) => {
    const KEY_TAB = 9;
    const { keyCode } = event || {};
    if (keyCode === KEY_TAB && this.props.api.suppressTab) {
      event.preventDefault();
    }
  };

  render() {
    const {
      OptionRenderer,
      fieldName,
      inputRef,
      openMenuOnFocus,
      placeholder,
      reactContainer,
      errorMessage,
    } = this.props;
    return (
      <SearchSelect
        onChange={this.handleChange}
        onInputChange={this.onInputChange}
        inputValue={this.state.inputValue}
        getOptionLabel={(e) => {
          return e[fieldName] ?? e.label;
        }}
        getOptionValue={(e) => e[fieldName] ?? e.label}
        fetchOptions={this.fetchOptions}
        onKeyDown={this.handleKeyDown}
        OptionRenderer={OptionRenderer}
        inputRef={inputRef}
        openMenuOnFocus={openMenuOnFocus ?? false}
        placeholder={placeholder ?? "Select..."}
        hasError={this.state.hasError}
        errorMessage={errorMessage}
        reactContainer={reactContainer}
      />
    );
  }
}

export default SelectComponent;
